// Normalized shape for every failure the API client surfaces, so pages can
// branch on `code` (the backend's machine-readable error) without parsing
// raw fetch/Response objects themselves.
export default class ApiError extends Error {
  constructor({ message, status = null, code = null, details = null, retryAfterSeconds = null }) {
    super(message || 'Something went wrong. Please try again.');
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    // From a Retry-After header (seconds), when the server sent one.
    this.retryAfterSeconds = retryAfterSeconds;
  }
}
